// import { shortDescription } from "./envmaker/short-description.js";
import { getDocumentation } from "./robocon/documentation.js";

import RoboconLight from "../assets/dsls-logos/robocon_L.png";
import RoboconDark from "../assets/dsls-logos/robocon_D.png";

/**
 * Retrieves the constants for the AppCreator DSL.
 * @returns {Promise<Object>} The constants object.
 */
export const getRoboconConstants = async () => {
	const constants = {
		enabled: true,
		_id: "robocon",
		name: "Robocon",
		short: "robocon",
		description: "Robocon is a powerful Domain-Specific Language (DSL) designed to simplify the integration of ROS (Robot Operating System) and ROS 2 systems with IoT and Smart Environment infrastructures.",
		logoUrl: RoboconLight,
		logoUrlDark: RoboconDark,
		insertableEntities: {},
		shortDescription: await getDocumentation(),
		documentation: await getDocumentation(),
		subtypes: [],
		hasValidation: true,
		type: "Textual",
		canTransformTo: [],
		mustImport: [],
		canImport: [],
		supportsGeneration: true,
		generationLanguage: "",
		supportsDeployment: false,
		deploymentStoppable: false,
		generations: ["Default"],
		generationsOutputMap: {
			Default: "file",
		},
		keywords: [],
		llmSupport: false,
		tags: ["IoT", "CPS", "Textual"],
		// autosave: false,
		experimental: true,
		initiallyCollapsed: true,
	};
	return constants;
};
